import { createContext, useContext, useState, useCallback } from "react";
import Modal from "@/components/Modal";

const Ctx = createContext(() => {});
export const usePdfViewer = () => useContext(Ctx);

export function PdfViewerProvider({ children }) {
  const [state, setState] = useState(null);

  const open = useCallback(async (title, loader) => {
    setState({ title, url: null, loading: true, error: null });
    try {
      const url = await loader();
      setState({ title, url, loading: false, error: null });
    } catch (e) {
      setState({ title, url: null, loading: false, error: "Génération du document impossible. Réessayez." });
    }
  }, []);

  return (
    <Ctx.Provider value={open}>
      {children}
      <Modal
        open={!!state}
        onClose={() => setState(null)}
        title={state?.title || "Document"}
        wide
        testId="pdf-viewer-modal"
        footer={
          <>
            {state?.url && <a href={state.url} target="_blank" rel="noreferrer" className="btn-outline" data-testid="pdf-open-tab">Ouvrir dans un onglet</a>}
            {state?.url && <a href={state.url} download className="btn-primary" data-testid="pdf-download">Télécharger</a>}
            <button className="btn-outline" onClick={() => setState(null)}>Fermer</button>
          </>
        }
      >
        {state?.loading && <div className="py-20 text-center text-[#64748B]">Génération du PDF…</div>}
        {state?.error && <div className="py-20 text-center text-[#B91C1C]">{state.error}</div>}
        {state?.url && <iframe title="Aperçu PDF" src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(state.url)}`} className="w-full h-[70vh] rounded-lg border border-[#E7ECF3] bg-white" data-testid="pdf-iframe" />}
      </Modal>
    </Ctx.Provider>
  );
}
